import call from '@amo/core/assets/images/icons/call.png';
import zarco from '@amo/core/assets/images/icons/zarco.png';
import { BulleAide, ConsentementRecontact } from '@amo/core/components/containers';
import { normalizeTel } from '@amo/core/utils/normalize.js';
import _ from 'lodash';
import Nom from './Nom/Nom';
import NumeroTel from './NumeroTel/NumeroTel';
import Prenom from './Prenom/Prenom';
import {getTranslation} from "@amo/core/utils/index.js";

const Coordonnees = (props) => {
    const { setStepForm, data, apporteur1, apporteur2, utm_source, bookingMode, postDemandeRappel, setShowBooking, token, canal, nameWhitelabel } = props;
    const isAprilMoto = nameWhitelabel === 'APRIL Moto';
    const rgpdLetterUrl = isAprilMoto
        ? 'https://www.april-moto.com/wp-content/uploads/2021/11/Lettre-RGPD-APRIL-Moto-AM21-11.pdf'
        : 'https://www.amgestionassurance.com/Doc/Lettre-RGPD-AM-Gestion-11.2021.pdf';
    const telApporteur2 = {
        67256: '0279834142',
        100122: '0219011492',
        101853: '0219011491',
        393798: '0279834145',
    };
    let tel;

    if (apporteur1.codeBelair === 809466) {
        tel = '0487937213';
    } else if (apporteur2) {
        tel = telApporteur2[apporteur2.codeBelair] || (utm_source === 'lrdm' ? '0219011493' : '0219011494');
    } else if (utm_source === 'april') {
        tel = '0255453459';
    } else {
        tel = utm_source === 'lrdm' ? '0219011493' : '0219011494';
    }

    return (
        <>
            <div className="row justify-content-center">
                <div className={'col-12 mb-4'}>
                    <div className={'row align-items-center justify-content-center'}>
                        <div className={'col-4 col-lg-2 text-center'}>
                            <img src={zarco} alt="" aria-hidden="true" loading="lazy"/>
                        </div>
                        <div className={'col-8 col-lg-5 text-start'}>
                            <h2 className={'text-dark f-24 fw-bold mt-4 mb-2'}>{getTranslation('callMeBack.title')}</h2>
                            <h3 className={'text-dark f-18 fw-bold mb-4'}>{getTranslation('callMeBack.yourDetails')}</h3>
                        </div>
                    </div>
                </div>
            </div>

            <Nom {...props} />

            <Prenom {...props} />

            <NumeroTel {...props} />

            <div className={'row justify-content-center'}>
                <div className={'col-lg-8 col-md-10 col-sm-10 col-12 my-2'}>
                    <small className={'text-start d-block f-12'}>
                        {getTranslation('callMeBack.rgpdInfo', { nameWhitelabel: isAprilMoto ? 'APRIL Moto' : 'AM Gestion' })}{' '}
                        <a
                            href={rgpdLetterUrl}
                            target={'_blank'}
                            rel="noopener noreferrer"
                        >
                            {getTranslation('callMeBack.rgpdLinkText')}
                            <span className="visually-hidden"> (nouvelle fenêtre)</span>
                        </a>
                        .
                    </small>
                </div>
            </div>

            <div className={'row justify-content-center'}>
                <div className={'col-lg-8 col-md-10 col-sm-10 col-12 my-2'}>
                    <div className={'row align-items-center'}>
                        <div className={'col-12 col-lg-7 text-start'}>
                            <p className={'f-14'} dangerouslySetInnerHTML={{__html: getTranslation('callMeBack.usTeam')}} />
                        </div>
                        <div className={'col-12 col-lg-5 text-lg-end text-center pt-2 pt-lg-0'}>
                            <a href={`tel:${tel}`} className={'f-20 fw-bold text-secondary text-decoration-none'}>
                                <img src={call} alt="" aria-hidden="true" loading="lazy"/> {normalizeTel(tel)}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            
            {apporteur1.codeBelair === 43397 && (
                <BulleAide
                    title={getTranslation('callMeBack.warning')}
                    className={'my-4 col-lg-8 offset-lg-2 col-md-12'}
                />
            )}

            <button
                type="button"
                className={`cursor-pointer btn btn-primary btn-arrow btn-smaller mb-2`}
                disabled={
                    !_.get(data, 'booking_nom') ||
                    !_.get(data, 'booking_prenom') ||
                    !_.get(data, 'booking_tel') ||
                    !_.get(data, 'accept-recontact')
                }
                onClick={() => {
                    if (bookingMode === 'asap') {
                        const formData = {
                            nom: data.booking_nom,
                            prenom: data.booking_prenom,
                            tel: data.booking_tel,
                            asap: true,
                            ap1: `${apporteur1?.codeBelair}`,
                            token,
                            canal,
                        };
                        postDemandeRappel(formData);
                        setShowBooking(false);
                    } else if (bookingMode === 'rdv') {
                        setStepForm(3);
                    } else {
                        setStepForm(2);
                    }
                }}
            >
                {getTranslation('next')}
            </button>

            <div className={'row justify-content-center'}>
                <div className={'col-lg-8 col-md-10 col-sm-10 col-12 mt-3'}>
                    <ConsentementRecontact compact />
                </div>
            </div>
        </>
    );
};

export default Coordonnees;
